import i18next from 'i18next';

import {CodeResponseType} from 'types/validation';

import {DocumentsCodesTreeRow, ProductContentRawRow} from '../types';

const collectIdentityCodes = (node: CodeResponseType['info']): string[] => {
    const children = node.childrenMarkingCodes ?? [];
    return [node.identityCode, ...children.flatMap((child) => collectIdentityCodes(child))];
};

export const invoiceValidationWithTransportCodes = (response: CodeResponseType, data: string[]) => {
    const {errors, isValid, info} = response;
    const mappedErrors: string[] = errors.map((e) => e.message);

    if (!isValid) mappedErrors.push(i18next.t('components.scan.errors.invalid_status'));

    const allIdentityCodes = collectIdentityCodes(info);
    const hasDuplicate = allIdentityCodes.some((code) => data.includes(code));
    if (hasDuplicate) {
        mappedErrors.push(i18next.t('components.scan.errors.double'));
    }

    return mappedErrors;
};

export const goodsDeclarationValidation = (resposne: CodeResponseType, data: any[]) => {
    const {errors, isValid, info} = resposne;
    const mappedErrors: string[] = errors.map((e) => e.message);

    if (!isValid) mappedErrors.push(i18next.t('components.scan.errors.invalid_status'));

    if (data.find((d) => d.markingCode === info.identityCode))
        mappedErrors.push(i18next.t('components.scan.errors.double'));

    return mappedErrors;
};

export const formatNavigationCodesTreeRow = (row: ProductContentRawRow): DocumentsCodesTreeRow => ({
    identityCode: row.markingCode,
    gtin: row.gtin,
    productName: row.productName,
    status: row.status,
    packagingType: row.packagingType,
});
